export default (params) => `
  <soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/" xmlns:web="http://webservice/">
    <soapenv:Header/>
    <soapenv:Body>
      <web:getPayingCurrencies>
        <sourceCountryId>${params.sourceCountryId}</sourceCountryId>
        <userId>${params.userId}</userId>
        <userKey>${params.userKey}</userKey>
      </web:getPayingCurrencies>
    </soapenv:Body>
  </soapenv:Envelope>
`
